import { Media } from "./media";

export class CarouselSend {

    constructor(item: CarouselSend|void) {
        if(item instanceof Object) {
            this.userId = item.userId;
            this.media = item.media;
        }
    }

    userId: string = "";
    media: Carousel[] = [];
}
export class CarouselBD {

    constructor(item: CarouselBD|void) {
        if( item instanceof Object) {
            this.order = item.order;
            this.file = item.file;
        }
    }

    order: number = -1;
    file: string = "";
}
export class Carousel {

    constructor(item: Carousel|void) {
        if( item instanceof Object) {
            this.order = item.order;
            this.file = new Media(item.file);
        }
    }

    order: number = -1;
    file: Media = new Media();
}
